<template>
  <div>
    <div class="d-flex align-center mb-8">
      <h1 class="">
        flex等宽列布局
      </h1>
    </div>
    <portal to="app-header">
      <div class="d-flex">
        <v-btn
          class="ml-2"
          small
          @click="add"
        >
          添加lorem到text
        </v-btn>
        <v-btn
          class="ml-2"
          small
          @click="text = ''"
        >
          清空text
        </v-btn>
        <VSpacer />
        <a class="ml-2" href="https://css-tricks.com/equal-columns-with-flexbox-its-more-complicated-than-you-might-think/">Equal Columns With Flexbox</a>
        <a class="ml-2" href="https://css-tricks.com/understanding-flex-grow-flex-shrink-and-flex-basis/">flex-grow, flex-shrink, and flex-basis</a>
      </div>
    </portal>
    <div class="box1">
      <div>1 单纯的父元素display: flex;<span class="red--text">{{ text }}</span></div>
      <div>2 单纯的父元素display: flex;<span class="red--text">{{ text }}</span></div>
      <div>3 单纯的父元素display: flex;<span class="red--text">{{ text }}</span></div>
    </div>

    <div class="box2 my-8">
      <p class="p">
        测试`width: max-content`浏览器假装它有无限的空间，并将所有文本放在一行中，同时测量其宽度Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium suscipit sit rerum autem velit laboriosam ex deserunt iure at, quam magnam et minima atque quidem non saepe! Doloremque, perferendis atque.
        <span class="red--text">{{ text }}</span>
      </p>
    </div>

    <div class="box3 my-8 overflow-auto">
      <div>1 width: max-content; 父元素不修改display 模拟flex column<span class="red--text">{{ text }}</span></div>
      <div>2 width: max-content; 父元素不修改display 模拟flex column<span class="red--text">{{ text }}</span></div>
      <div>3 width: max-content; 父元素不修改display 模拟flex column<span class="red--text">{{ text }}</span></div>
    </div>

    <div class="box4 my-8 overflow-auto">
      <div class="item">
        子元素默认添加 `flex-shrink: 1;`Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus veniam, quidem officiis totam architecto asperiores, eligendi aperiam distinctio fugit voluptas voluptatibus! Repudiandae quis minus iusto dolorem asperiores, iure similique atque.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="item">
        子元素默认添加 `flex-shrink: 1;`Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus veniam, quidem officiis totam architecto asperiores, eligendi aperiam distinctio fugit voluptas voluptatibus! Repudiandae quis minus iusto dolorem asperiores, iure similique atque.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="item">
        子元素默认添加 `flex-shrink: 1;`Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus veniam, quidem officiis totam architecto asperiores, eligendi aperiam distinctio fugit voluptas voluptatibus! Repudiandae quis minus iusto dolorem asperiores, iure similique atque.
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <div class="box4 my-8 overflow-auto">
      <div class="item no-shrik">
        flex-shrink: 0;<span class="red--text">{{ text }}</span>
      </div>
      <div class="item no-shrik">
        flex-shrink: 0;<span class="red--text">{{ text }}</span>
      </div>
      <div class="item no-shrik">
        flex-shrink: 0;<span class="red--text">{{ text }}</span>
      </div>
    </div>

    <a href="https://css-tricks.com/equal-columns-with-flexbox-its-more-complicated-than-you-might-think/#aa-heres-why-the-columns-arent-equal">
      这就是列不相等的原因 默认是flex-shrink: 1; 如果我们将所有三个 Flex 项目的所有基本尺寸（我们在其上声明的实际宽度）相加，则总数为1200px。我们的柔性容器很600px宽。如果我们将所有内容除以 2，就合适了！它们都以相同的速率收缩，将它们自己的宽度除以 2。
    </a>
    <div class="box5 my-8 overflow-auto">
      <div class="item">
        width: 300px; 变150px Lorem ipsum dolor sit amet consectetur adipisicing elit.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="item big">
        width: 600px; 变300px Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="item">
        width: 300px; 变150px Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <p>使列相等 方法一：使用flex: 1</p>
    <div class="box6 my-8">
      <div class="">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <p>子元素padding会有影响 不等宽了</p>
    <p>默认flex会
<pre>
.selector {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
}
</pre>
所以默认情况下，弹性项目：
不成长；
如果它们会溢出父级，则允许它们缩小；
它们的宽度就像max-content.
即：
<pre>
.selector {
  flex: 0 1 auto;
}
</pre>
    </p>
    <div class="box7 my-8">
      <div class="">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, voluptas.
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <div class="box8 my-8">
      <div class="">
        box8
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        box8
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        box8
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <div class="box9 my-8">
      <div class="">
        box9 (宽度-中间元素左右padding)/3 = (600 - 40)/3 = 186.6667
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        box9中间带了padding20px就是 (宽度-中间元素左右padding)/3 + padding-left + padding-right
        就是 ((600-40)/3 + 40) = 186.6667 + 20 + 20 = 226.6667
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        box9 (宽度-中间元素左右padding)/3 = (600 - 40)/3 = 186.6667
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <p>方法二：flex-basis: 100%</p>
    <div class="box10 my-8">
      <div class="">
        10
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        box10 flex-basis: 100%;
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        box10 flex-basis: 100%;
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus error quam vitae optio hic libero ipsam voluptatibus veniam doloremque temporibus, excepturi, debitis consectetur esse at explicabo, voluptatum dolore omnis earum.
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <p>来自渡一哥的flex布局</p>
    <div class="box11 my-8">
      <div class="">
        flex-grow: 1; flex-basis: 0%;
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        flex-grow: 1; flex-basis: 0%;
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        flex-grow: 1; flex-basis: 0%;
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus error quam vitae optio hic libero ipsam voluptatibus veniam doloremque temporibus, excepturi, debitis consectetur esse at explicabo, voluptatum dolore omnis earum.
        <span class="red--text">{{ text }}</span>
      </div>
    </div>

    <p>grid布局 好</p>
    <p>我意识到我们可以通过将元素嵌套在padding其上来使用 Flexbox 来解决这个问题。自从我们开始使用浮动进行布局以来，我们就这样做了，Bootstrap 确实很好地实现了这种类型的设计模式</p>
    <div class="box12 my-8">
      <div class="">
        grid布局只改父元素 好
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        grid布局只改父元素 好
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Adipisci quae, vitae ad voluptatibus molestiae voluptas quis incidunt, ullam quas totam laboriosam possimus suscipit commodi placeat aspernatur provident tempora? Placeat, maxime.
        <span class="red--text">{{ text }}</span>
      </div>
      <div class="">
        grid布局只改父元素 好
        <span class="red--text">{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        text: '',
      }
    },
    mounted() {

    },
    methods: {
      add() {
        this.text += 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'
      },

    }
  }
</script>

<style lang="scss" scoped>
@function random-rgb() {
  $red: random(255);
  $green: random(255);
  $blue: random(255);
  @return rgb($red, $green, $blue);
}

@function random-rgba() {
  $red: random(255);
  $green: random(255);
  $blue: random(255);
  $alpha: random() * 1; // 生成 0 到 1 之间的随机数作为 alpha 通道值
  @return rgba($red, $green, $blue, $alpha);
}

.box1 {
  display: flex;
  background-color: rgba(255, 192, 203, 0.2);
  div {
    padding: .5em;
    background: rgba(239, 239, 239, 0.45);
    border: 3px solid #333;
  }
}

.box2 {
  background-color: rgba(176, 163, 163, 0.395);
  overflow: auto;
  height: 50px;
  .p {
    border: 1px solid;
    width: max-content;
  }
}

// 测试 width: max-content;
.box3 {
  // display: flex;
  background-color: rgba(255, 192, 203, 0.2);
  div {
    width: max-content;
    padding: .5em;
    background: rgba(239, 239, 239, 0.45);
    border: 3px solid #333;
  }
}

// 添加flex-shrink
.box4 {
  background-color: rgba(255, 192, 203, 0.2);
  display: flex;
  .item {
    padding: .5em;
    background: rgba(239, 239, 239, 0.45);
    border: 3px solid #333;
  }
  .item.no-shrik {
    flex-shrink: 0;
  }
}

.box5 {
  background-color: rgba(255, 192, 203, 0.2);
  display: flex;
  width: 600px;
  margin: 0 auto;
  .item {
    background: rgba(129, 129, 129, 0.45);
    width: 300px;
  }
  .item.big {
    background: rgba(72, 131, 106, 0.45);
    width: 600px;
  }
}

.box6 {
  display: flex;
  > * {
    flex: 1;
    // 随机背景色
    background-color: random-rgba();
  }
  :nth-child(2) {
    flex: 1;
    background-color: random-rgb();
  }
}

.box7 {
  display: flex;
  gap: 1em;
  > * {
    flex: 1;
    // 随机背景色
    background-color: random-rgba();
  }
  :nth-child(2) {
    flex: 1;
    background-color: random-rgb();
    padding: 2em;
    border-radius: 0.3rem;
  }
}


.box8 {
  display: flex;
  gap: 1em;
  > * {
    flex: 1;
    /* flex-grow: 1; */
    /* flex-shrink: 1; */
    /* flex-basis: 0%; Wait what? => 其行为类似于.我们所有的弹性项目现在都希望有一个基本尺寸！flex-basis0%max-content0 */
    // 所以它们的基本尺寸0现在是，但由于flex-grow，它们都可以增长以填充空白空间。实际上，在这种情况下，flex-shrink不再执行任何操作，因为所有弹性项目现在的宽度均为0，并且正在增长以填充可用空间。
  
    // 随机背景色
    background-color: random-rgba();
  }
  :nth-child(2) {
    flex: 1;
    background-color: random-rgb();
    border-radius: 0.3rem;
  }
}

.box9 {
  display: flex;
  width: 600px;
  margin: 0 auto;
  background-color: random-rgba();
  > * {
    flex: 1;
    // 随机背景色
    background-color: random-rgba();
  }
  :nth-child(2) {
    flex: 1;
    padding: 20px;
    background-color: random-rgb();
    border-radius: 0.3rem;
  }
}

.box10 {
  display: flex;
  background-color: random-rgba();
  > * {
    flex-basis: 100%;
    background-color: random-rgba();
    margin: 10px;
    padding: 5px;
  }
  :nth-child(2) {
    background-color: random-rgba();
  }
}

.box11 {
  display: flex;
  background-color: random-rgba();
  > * {
    flex-grow: 1;
    flex-basis: 0%;
    background-color: random-rgba();
    margin: 10px;
    padding: 5px;
  }
  :nth-child(2) {
    background-color: random-rgba();
  }
}

.box12 {
  display: grid;
  gap: 1em;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  background-color: random-rgba();
  @media (min-width: 35em) {
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }
  > * {
    background-color: random-rgba();
    margin: 10px;
    margin: 10px;
    padding: 5px;
  }
  :nth-child(2) {
    background-color: random-rgba();
  }
}

</style>